module.exports = __webpack_public_path__ + "img/bandedCharm.88a087e2.png";